import ca from './locales/ca.json';
import de from './locales/de.json';
import es from './locales/es.json';
import it from './locales/it.json';
import fr from './locales/fr.json';
import zh from './locales/zh.json';

export default (key, system) => {
    let pathKeys = key;
    if(Array.isArray(key)){
        pathKeys.forEach((val, idx) => {
            pathKeys[idx] = (system.urlPrefix + val).split(',');
        });
    } else {
        pathKeys = [system.urlPrefix + key];
    }

    pathKeys.forEach(key => {
        if (ca[key]) pathKeys.push(system.urlPrefix + "/ca" + ca[key]);
        if (de[key]) pathKeys.push(system.urlPrefix + "/de" + de[key]);
        if (es[key]) pathKeys.push(system.urlPrefix + "/es" + es[key]);
        if (fr[key]) pathKeys.push(system.urlPrefix + "/fr" + fr[key]);
        if (it[key]) pathKeys.push(system.urlPrefix + "/it" + it[key]);
        if (zh[key]) pathKeys.push(system.urlPrefix + "/zh" + zh[key]);
    });

    // pathKeys.forEach(key => {
    //     if(Array.isArray(key)){
    //         key.push(
    //             system.urlPrefix + "/en" + key, 
    //             system.urlPrefix + "/ca" + key, 
    //             system.urlPrefix + "/de" + key, 
    //             system.urlPrefix + "/es" + key, 
    //             system.urlPrefix + "/fr" + key,
    //             system.urlPrefix + "/it" + key,
    //             system.urlPrefix + "/zh" + key
    //         );
    //     }
    // });

    return pathKeys;
}
